import { render } from "./LoaderUI.vue?vue&type=template&id=09eccab0&scoped=true"
import script from "./LoaderUI.vue?vue&type=script&lang=js"
export * from "./LoaderUI.vue?vue&type=script&lang=js"

import "./LoaderUI.vue?vue&type=style&index=0&id=09eccab0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09eccab0"]])

export default __exports__